import React from 'react';
import styled, { css } from 'styled-components';
import { primary } from '@salutejs/plasma-core';
var sizeMap = {
  xs: 1,
  // 16px
  s: 1.5 // 24px
  // m: 2.25, // 36px
  // l: 3, // 48px
  // xl: 3.5, // 56px
  // xxl: 4, // 64px

};
var StyledRoot = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-1x30mn6-0"
})(["display:inline-flex;", ""], function (_ref) {
  var w = _ref.w;
  return css(["width:", ";height:", ";flex:0 0 ", ";"], w, w, w);
});
export var IconRoot = function IconRoot(_ref2) {
  var IconComponent = _ref2.icon,
      size = _ref2.size,
      color = _ref2.color,
      className = _ref2.className;
  var c = color || primary;
  var w = "".concat(sizeMap[size], "rem");
  return /*#__PURE__*/React.createElement(StyledRoot, {
    "aria-hidden": true,
    w: w,
    className: className
  }, /*#__PURE__*/React.createElement(IconComponent, {
    color: c,
    size: size
  }));
};